import { z } from "zod";

export const KeycloakConfigSchema = z.object({
  url: z.string(),
  realm: z.string(),
  clientId: z.string(),
  credentials: z.object({
    secret: z.string(),
  }),
});

export type KeycloakConfigType = z.infer<typeof KeycloakConfigSchema>;
